// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.comment_wrapper__LzXg4 {
  margin-top: 100px;
}

.comment_cursor-pointer__mGkYu {
  cursor: pointer;
}

.comment_title__\\+GDTz {
  font-size: 2rem;
  font-weight: 700;
}

.comment_author__ZkoZZ {
  font-weight: 700;
  font-size: 1.8rem;
}

.comment_text-content__InB9d {
  font-size: 1.7rem;
  word-wrap: break-word; /* Ngắt dòng khi cần */
  word-break: break-word; /* Hỗ trợ các từ dài */
  overflow-wrap: break-word; /* Thêm tùy chọn cho các trình duyệt khác */
}

.comment_fix_content__o9LUb {
  font-size: 1.6rem;
}

.comment_btn-text__g7jHr {
  font-size: 1.4rem;
  display: flex;
  align-items: start;
}

.comment_comment__wlVI4 {
  border: 1px solid #111;
  width: 100%;
  font-size: 1.8rem;
  resize: none;
}
.comment_comment__wlVI4:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.comment_new-comment__tN4TL {
  font-size: 1.6rem;
}
.comment_new-comment__tN4TL:hover {
  color: #6c757d;
  background-color: transparent;
}

.comment_quill__No0WB p {
  font-size: 1.8rem;
}

.comment_quill__No0WB ::placeholder {
  font-size: 1.8rem;
}

.comment_ql-editor__DKb2I::before {
  font-size: 18px !important; /* Tăng kích thước */
  color: gray !important; /* Màu chữ */
  font-style: normal !important; /* Chữ thẳng */
  opacity: 1 !important; /* Đảm bảo placeholder hiển thị rõ */
}`, "",{"version":3,"sources":["webpack://./src/Layout/comment/comment.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACG,iBAAA;AAEH;;AAAA;EACM,eAAA;AAGN;;AAAA;EACI,eAAA;EACA,gBAAA;AAGJ;;AADA;EACI,gBAAA;EACA,iBAAA;AAIJ;;AAFA;EACI,iBAAA;EACA,qBAAA,EAAA,sBAAA;EACF,sBAAA,EAAA,sBAAA;EACA,yBAAA,EAAA,2CAAA;AAKF;;AAHA;EAEI,iBAAA;AAKJ;;AAFA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;AAKJ;;AAFA;EACI,sBAAA;EAEA,WAAA;EACA,iBAAA;EACA,YAAA;AAIJ;AAAI;EACI,aAAA;EACA,4DAAA;EACA,qBAAA;AAER;;AACA;EACI,iBAAA;AAEJ;AAAI;EACI,cAAA;EACA,6BAAA;AAER;;AAEA;EACI,iBAAA;AACJ;;AACA;EACI,iBAAA;AAEJ;;AAAA;EACI,0BAAA,EAAA,oBAAA;EACA,sBAAA,EAAA,YAAA;EACA,6BAAA,EAAA,cAAA;EACA,qBAAA,EAAA,oCAAA;AAGJ","sourcesContent":[".wrapper{\n   margin-top: 100px;\n}\n.cursor-pointer {\n      cursor: pointer;\n    }\n\n.title{\n    font-size: 2rem;\n    font-weight: 700;\n}\n.author{\n    font-weight: 700;\n    font-size: 1.8rem;\n}\n.text-content{\n    font-size: 1.7rem;\n    word-wrap: break-word; /* Ngắt dòng khi cần */\n  word-break: break-word; /* Hỗ trợ các từ dài */\n  overflow-wrap: break-word; /* Thêm tùy chọn cho các trình duyệt khác */\n}\n.fix_content{\n    // margin-top: 10px;\n    font-size: 1.6rem;\n    \n}\n.btn-text{\n    font-size: 1.4rem;\n    display: flex;\n    align-items: start;\n}\n\n.comment{\n    border: 1px solid #111;\n    // padding-right: 8rem;\n    width: 100%;\n    font-size: 1.8rem;\n    resize: none;//chan keo len xuong cua textarea\n    \n\n    \n    &:focus{\n        outline: none;\n        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n        border-color: #6c757d;\n  }\n}\n.new-comment{\n    font-size: 1.6rem;\n\n    &:hover{\n        color: #6c757d;\n        background-color: transparent;\n    }\n}\n\n.quill p {\n    font-size: 1.8rem;\n}\n.quill ::placeholder{\n    font-size: 1.8rem;\n}\n.ql-editor::before {\n    font-size: 18px !important;  /* Tăng kích thước */\n    color: gray !important;      /* Màu chữ */\n    font-style: normal !important; /* Chữ thẳng */\n    opacity: 1 !important;       /* Đảm bảo placeholder hiển thị rõ */\n}\n\n\n\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `comment_wrapper__LzXg4`,
	"cursor-pointer": `comment_cursor-pointer__mGkYu`,
	"title": `comment_title__+GDTz`,
	"author": `comment_author__ZkoZZ`,
	"text-content": `comment_text-content__InB9d`,
	"fix_content": `comment_fix_content__o9LUb`,
	"btn-text": `comment_btn-text__g7jHr`,
	"comment": `comment_comment__wlVI4`,
	"new-comment": `comment_new-comment__tN4TL`,
	"quill": `comment_quill__No0WB`,
	"ql-editor": `comment_ql-editor__DKb2I`
};
export default ___CSS_LOADER_EXPORT___;
